import React from 'react';
import { Link } from '@inertiajs/react';
import classNames from 'classnames';
import Icon from '@/Shared/Icon';

export default ({
	icon,
	link,
	text,
	containerClasses = '',
	newLabel = false
}) => {
	const isActive = route().current(link + '*');

	const iconClasses = classNames('mr-1.5 fill-current', {
		'fill-current': isActive,
		'fill-current': !isActive
	});

	const textClasses = classNames('text-sm xl:text-lg', {
		'main-menu-item-selected': isActive,
		'main-menu-item': !isActive
	});

	return (
		<div
			className={
				'fill-current' + containerClasses ? ' ' + containerClasses : ''
			}
		>
			<Link href={route(link)} className="flex items-center group">
				<Icon name={icon} className={iconClasses} />
				<div className={textClasses}>
					{text}
					{newLabel ? (
						<span className="bg-accent font-bold mx-1 px-1 rounded text-sm text-white">
							NEW
						</span>
					) : (
						<></>
					)}
				</div>
			</Link>
		</div>
	);
};
